import { Tools } from 'bundles/cml';

// The default value empty being set by `plainTextConverter.toCML`
export const EMPTY_CML_VALUE = '<co-content><text></text></co-content>';

export const GRADING_DTD_ID = 'graderFeedback/1';

// Note: particularly for grader's MultiLineInput feedback we need a limited set of options, defined here
export const EDITOR_TOOLS = [
  Tools.BOLD,
  Tools.ITALIC,
  Tools.UNDERLINE,
  Tools.CODE,
  Tools.MATH,
  Tools.LINK,
  Tools.UNLINK,
];
